// @ai-generated 2026-09-17T10:27:43+00:00 by niklas.eicker@tngtech.com using Claude Opus 5 (1M context)
import { useChatThreads, useDeleteChatThread } from '@Hooks/AgenticOrchestrator/useChatThreads';
import { type ApiChatThread } from '@Model';
import { renderDateTime, Tooltip } from '@synqo/frontend-component-library';
import { IconChevronLeft, IconPlus, IconX } from '@tabler/icons-react';
import classes from './ChatThreadRail.module.css';

interface ChatThreadRailProps {
    activeConversationId: string;
    collapsed: boolean;
    onToggleCollapsed: () => void;
    onSelect: (conversationId: string) => void;
    onNew: () => void;
    onDeleted: (conversationId: string) => void;
}

/** The user's own conversations beside the chat, most recent first. */
export function ChatThreadRail({
    activeConversationId,
    collapsed,
    onToggleCollapsed,
    onSelect,
    onNew,
    onDeleted,
}: ChatThreadRailProps) {
    const { threads, isLoading } = useChatThreads();
    const { deleteThread, isDeleting } = useDeleteChatThread();

    const remove = async (thread: ApiChatThread) => {
        await deleteThread(thread.id);
        onDeleted(thread.conversation_id);
    };

    const toggleLabel = collapsed ? 'Chatverlauf einblenden' : 'Chatverläufe ausblenden';

    return (
        <div className={`${classes.rail} ${collapsed ? classes.collapsed : ''}`}>
            <div className={classes.header}>
                {!collapsed && <span className={classes.headerLabel}>Chatverläufe</span>}
                <Tooltip label={toggleLabel}>
                    <button
                        type="button"
                        aria-label={toggleLabel}
                        className={classes.iconButton}
                        onClick={onToggleCollapsed}
                    >
                        <IconChevronLeft
                            size={16}
                            className={`${classes.chevron} ${collapsed ? classes.pointBack : ''}`}
                        />
                    </button>
                </Tooltip>
            </div>
            {collapsed ? (
                <Tooltip label="Neuer Chat">
                    <button type="button" aria-label="Neuer Chat" className={classes.iconButton} onClick={onNew}>
                        <IconPlus size={16} />
                    </button>
                </Tooltip>
            ) : (
                <button type="button" className={classes.newChat} onClick={onNew}>
                    <IconPlus size={14} />
                    Neuer Chat
                </button>
            )}
            {!collapsed && isLoading && <div className={classes.empty}>Wird geladen…</div>}
            {!collapsed && !isLoading && threads.length === 0 && <div className={classes.empty}>Noch keine Chats.</div>}
            <div className={classes.list} hidden={collapsed}>
                {threads.map((thread) => (
                    <div
                        key={thread.id}
                        className={`${classes.entry} ${
                            thread.conversation_id === activeConversationId ? classes.entryActive : ''
                        }`}
                    >
                        <button
                            type="button"
                            className={classes.entryButton}
                            onClick={() => onSelect(thread.conversation_id)}
                        >
                            <span className={classes.entryTitle}>{thread.title || 'Ohne Titel'}</span>
                            <span className={classes.entryDate}>{renderDateTime(thread.updated_at, 'datetime')}</span>
                        </button>
                        <Tooltip label="Chat löschen">
                            <button
                                type="button"
                                aria-label="Chat löschen"
                                className={classes.deleteButton}
                                disabled={isDeleting}
                                onClick={() => void remove(thread)}
                            >
                                <IconX size={14} />
                            </button>
                        </Tooltip>
                    </div>
                ))}
            </div>
        </div>
    );
}
